import './room-type.scss';

import { Outlet } from "react-router-dom";

import { FilterRoomTypeProvider } from "./filter-room-type/filter-room-type.context";

export function RoomType() {
  return (
    <div id="ShellRoomType" className="room-type">
       <FilterRoomTypeProvider>
        <Outlet />
      </FilterRoomTypeProvider>
    </div>
  );
}

export default RoomType;
